import { computed } from 'vue'
import { useStore } from 'vuex'
import { SchemaType } from '@/constants/schema'

const useReadModelDomainEvents = () => {
  const store = useStore()
  const workflow = computed(() => store.state.workflow.workflow)

  const allDomainEventSchemas = computed(() =>
    (workflow.value?.schemas ?? []).filter((s) => s.type === SchemaType.DOMAIN_EVENT)
  )

  const allReadModelSchemas = computed(() =>
    (workflow.value?.schemas ?? []).filter((s) => s.type === SchemaType.QUERY)
  )

  const getDomainEventsForReadModel = (readModelSchema) => {
    const ids = readModelSchema?.domainEventIds
    if (!Array.isArray(ids) || ids.length === 0) {
      return []
    }

    return ids.map((id) => allDomainEventSchemas.value.find((de) => de.id === id)).filter(Boolean)
  }

  const getReadModelsForDomainEvent = (domainEventSchema) => {
    if (!domainEventSchema) {
      return []
    }
    const deId = domainEventSchema.id

    return allReadModelSchemas.value.filter((rm) => {
      const ids = rm.domainEventIds

      return Array.isArray(ids) && ids.includes(deId)
    })
  }

  const getAvailableDomainEventsForReadModel = (readModelSchema) => {
    if (!readModelSchema) {
      return []
    }
    const ids = readModelSchema.domainEventIds || []

    return allDomainEventSchemas.value.filter((de) => !ids.includes(de.id))
  }

  const getSuggestedDomainEventsForReadModel = (readModelSchema) => {
    if (!readModelSchema?.entityId) {
      return []
    }

    const linkedIds = new Set(readModelSchema.domainEventIds || [])

    return allDomainEventSchemas.value.filter((de) =>
      de.entityId === readModelSchema.entityId && !linkedIds.has(de.id)
    )
  }

  return {
    getDomainEventsForReadModel,
    getReadModelsForDomainEvent,
    getAvailableDomainEventsForReadModel,
    getSuggestedDomainEventsForReadModel
  }
}

export default useReadModelDomainEvents
